export default __webpack_public_path__ + "static/media/open-hand.a560c3e6.svg";